import type { PmNodeConverter, PmNodeJson } from './../pm-converters/types';
import type { HTMLData } from './../ricos-schema/legacy/wix/rich_content/v1';
import { HTMLData_Source, Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { HtmlNode } from './../ricos-types';

export const htmlConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.HTML],
    // @ts-ignore $TSFixMe
    convert: (node: HtmlNode) => {
      return {
        type: Node_Type.HTML,
        attrs: {
          ...node.htmlData,
          id: node.id,
          autoHeight: node.htmlData.autoHeight ?? true,
        },
      };
    },
  },
  fromPm: {
    types: [Node_Type.HTML],
    convert: (node: PmNodeJson) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.HTML,
        id,
        nodes: [],
        htmlData: {
          ...(data as HTMLData),
          source: node.attrs?.source || HTMLData_Source.HTML,
          autoHeight: node.attrs?.autoHeight === false ? false : undefined,
          iframeHeight: undefined,
        },
      };
    },
  },
};
